import _taggedTemplateLiteral from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _classCallCheck from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      :host {\n        display: inline-block;\n        font-size: 14px;\n        text-align: left;\n      }\n      button {\n        cursor: pointer;\n        outline: none;\n        overflow: hidden;\n        color: inherit;\n        user-select: none;\n        position: relative;\n        font-family: inherit;\n        text-align: inherit;\n        font-size: inherit;\n        letter-spacing: 1.25px;\n        padding: 1px 10px;\n        min-height: 36px;\n        text-transform: inherit;\n        background: none;\n        border: none;\n        transition: background-color 0.3s ease, color 0.3s ease;\n        width: 100%;\n        box-sizing: border-box;\n        white-space: nowrap;\n      }\n      button.selected {\n        color: var(--wired-item-selected-color, #fff);\n      }\n      button::before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background: currentColor;\n        opacity: 0;\n      }\n      button span {\n        display: inline-block;\n        transition: transform 0.2s ease;\n        position: relative;\n      }\n      button:active span {\n        transform: scale(1.02);\n      }\n      #overlay {\n        display: none;\n      }\n      button.selected #overlay {\n        display: block;\n      }\n      svg path {\n        stroke: var(--wired-item-selected-bg, #000);\n        stroke-width: 2.75;\n        fill: transparent;\n        transition: transform 0.05s ease;\n      }\n      @media (hover: hover) {\n        button:hover::before {\n          opacity: 0.05;\n        }\n      }\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    <button class=\"", "\">\n      <div id=\"overlay\"><svg></svg></div>\n      <span><slot></slot></span>\n    </button>"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { WiredBase, BaseCSS } from 'wired-lib/lib/wired-base';
import { customElement, property, css, html } from 'lit-element';
import { hachureFill } from 'wired-lib';

var WiredItem = /*#__PURE__*/function (_WiredBase) {
  _inherits(WiredItem, _WiredBase);

  var _super = _createSuper(WiredItem);

  function WiredItem() {
    var _this;

    _classCallCheck(this, WiredItem);

    _this = _super.apply(this, arguments);
    _this.value = '';
    _this.name = '';
    _this.selected = false;
    return _this;
  }

  _createClass(WiredItem, [{
    key: "render",
    value: function render() {
      return html(_templateObject(), this.selected ? 'selected' : '');
    }
  }, {
    key: "canvasSize",
    value: function canvasSize() {
      var s = this.getBoundingClientRect();
      return [s.width, s.height];
    }
  }, {
    key: "draw",
    value: function draw(svg, size) {
      var g = hachureFill([[0, 0], [size[0], 0], [size[0], size[1]], [0, size[1]]], this.seed);
      svg.appendChild(g);
    }
  }], [{
    key: "styles",
    get: function get() {
      return [BaseCSS, css(_templateObject2())];
    }
  }]);

  return WiredItem;
}(WiredBase);

__decorate([property(), __metadata("design:type", Object)], WiredItem.prototype, "value", void 0);

__decorate([property(), __metadata("design:type", Object)], WiredItem.prototype, "name", void 0);

__decorate([property({
  type: Boolean
}), __metadata("design:type", Object)], WiredItem.prototype, "selected", void 0);

WiredItem = __decorate([customElement('wired-item')], WiredItem);
export { WiredItem };